/*
 * Copyright (c) 2020 JCA Electronics , Winnipeg, MB. All rights reserved.
 */
//SmartMap.Common.Models.PathModel
import { SimplePoint } from './SimplePoint';
import { Guid } from 'guid-typescript';
import { deserialize, deserializeArray, serialize, Type } from 'class-transformer';

export class SimplePath {
  PathID: string;
  CustomerID: string;
  FieldID: string;
  Path: SimplePoint[];
  WorkAreas: SimplePoint[][];
  CropAreas: SimplePoint[][];
  PathLengthMeters: number;
  StrokeOpacity: number;
  StrokeWeight: number;
  Name: string;
  @Type(() => Date)
  LastModifiedUTC: Date;

  constructor() {
    this.PathID = Guid.EMPTY.toString();
    this.CustomerID = Guid.EMPTY.toString();
    this.FieldID = Guid.EMPTY.toString();
    this.Path = [];
    this.WorkAreas = [[]];
    this.CropAreas = [[]];
    this.PathLengthMeters = 0;
    this.StrokeOpacity = 0;
    this.StrokeWeight = 0;
    this.Name = ' ';
    this.LastModifiedUTC = new Date();
  }

  static toModel(json: string): SimplePath {
    const model = deserialize(SimplePath, json);
    return model;
  }

  static toModelCollection(json: string): SimplePath[] {
    const models = deserializeArray(SimplePath, json);
    return models;
  }

  fromModelToJson(): string {
    const jsObj = serialize(this);
    return jsObj;
  }
}
